module.exports = __webpack_public_path__ + "assets/c406d1bbd2d79847613692a6578cb8ab.mp3";